<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.work_type')" filterable clearable :multiple="multiple"
      :size="size" class="d-block">
      <el-option v-for="(work_type,index) in work_types" :key="'work_types-' + index" :label="work_type.work_type_name" :value="work_type.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
        id:{
          default: null
        },
        multiple:{
            type: Boolean,
            default: false,
        }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.work_types && this.work_types.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        work_types: 'workType/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'workType/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
